import React, { useContext, useEffect, useState } from 'react'
import { Container, Footer, InputContainer, Row, Title } from './styled'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { Button } from '../../../../components/common/Button'
import { BaseContext } from '../../../../context/context_baseRegister'
import api from '../../../../services/api'
import { Modal } from '../../../../components/Modal'
import { CheckCircle } from '@phosphor-icons/react'
import axios from 'axios'

interface EditUserProps {
  onclick: () => void
  data: any
}
interface BaseDataProps {
  id: string
  base: string
  outpost: string
  Address: [
    {
      id: string
      address: string
      zipcode: string
      burgh: string
      city: string
      state: string
      latitude: number
      longitude: number
    },
  ]
}

interface IAddres {
  logradouro: string
  cep: string
  bairro: string
  localidade: string
  uf: string
}

export const EditUser: React.FC<EditUserProps> = ({ onclick, data }) => {
  const { states, maskCEP } = useContext(BaseContext)

  const [edit, setEdit] = useState<boolean>(false)
  const [confirm, setConfirm] = useState<boolean>(false)
  const [formData, setFormData] = useState<BaseDataProps>({
    id: '',
    base: '',
    outpost: '',
    Address: [
      {
        id: '',
        address: '',
        zipcode: '',
        burgh: '',
        city: '',
        state: '',
        latitude: 0,
        longitude: 0,
      },
    ],
  })

  useEffect(() => {
    if (data) {
      console.log(data)
      setFormData({
        id: data?.id,
        base: data?.base,
        outpost: data?.outpost,
        Address: [
          {
            id: data?.Address[0].id,
            address: data?.Address[0].address,
            zipcode: data?.Address[0].zipcode,
            burgh: data?.Address[0].burgh,
            city: data?.Address[0].city,
            state: data?.Address[0].state,
            latitude: 0,
            longitude: 0,
          },
        ],
      })
    }
  }, [data])

  const handleCepChange = async (cep: string) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)

      const addressData = {
        id: formData.Address[0].id,
        address: response.data.logradouro,
        zipcode: response.data.cep,
        burgh: response.data.bairro,
        city: response.data.localidade,
        state: response.data.uf,
        latitude: 0,
        longitude: 0,
      }

      setFormData((prev: any) => ({
        ...prev,
        Address: [addressData],
      }))
    } catch (error) {
      console.error('Erro na requisição:', error.message)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setFormData((prev) => {
      const updatedAddress = {
        ...prev.Address[0],
        [name]: value,
      }

      return {
        ...prev,
        Address: [updatedAddress],
      }
    })

    if (name === 'zipcode') {
      handleCepChange(value)
    }
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault()

    try {
      await api.put('/v1/dashboard/base/update', formData)
      console.log(formData, 'formData enviado')
      setEdit((prev) => !prev)
      setConfirm((prev) => !prev)
    } catch (error) {
      console.error('Erro ao atualizar:', error)
    }
  }

  return (
    <>
      <Container
        onSubmit={(e) => {
          e.preventDefault()
          setEdit((prev) => !prev)
        }}
      >
        <InputContainer>
          <Input.Root>
            <Input.Label
              title="Nome da base"
              htmlFor=""
              color=""
              fontSize="14px"
            />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                value={formData.base}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    base: e.target.value,
                  }))
                }}
                type="text"
                placeholder="Nome da base"
                name="base"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label
              title="Nome do posto"
              htmlFor=""
              color=""
              fontSize="14px"
            />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                value={formData?.outpost}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    outpost: e.target.value,
                  }))
                }}
                type="text"
                placeholder="Nome do posto"
                name="outpost"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>

        <Title>Endereço</Title>

        <InputContainer>
          <Input.Root>
            <Input.Label title="CEP" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                type="text"
                placeholder="xxxxx-xxxx"
                value={maskCEP(formData?.Address[0].zipcode)}
                onChange={handleChange}
                name="zipcode"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>

        <InputContainer>
          <Input.Root>
            <Input.Label title="Rua" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                type="text"
                placeholder="Rua"
                value={formData.Address[0].address}
                onChange={handleChange}
                name="address"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Bairro" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                type="text"
                value={formData.Address[0].burgh}
                onChange={handleChange}
                name="burgh"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Cidade" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                type="text"
                placeholder="Cidade"
                value={formData?.Address[0].city}
                onChange={handleChange}
                name="city"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>

        <Row>
          <InputContainer>
            <Select
              label={{
                title: 'Estado',
                htmlFor: '',
                color: '',
                fontSize: '14px',
              }}
              data={states}
              backgroundcolor=""
              bordercolor=""
              currentOption={formData?.Address[0].state}
              outlinecolor=""
              onchange={handleChange}
              name="state"
            />
          </InputContainer>
        </Row>

        <Footer>
          <Button.Root backgroundColor="#00517D" type="submit">
            <Button.Content title="Editar" color="#fff" />
          </Button.Root>
        </Footer>
      </Container>
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="35%"
        height="fit-content"
        left="50%"
        top="50%"
        open={edit}
        setIsOpenController={() => setEdit((prev) => !prev)}
      >
        <Modal.Header onclick={() => setEdit((prev) => !prev)} />
        <Modal.Content
          value="Você está atualizando os dados da base"
          subvalue="Ao clicar em salvar, você estará atualizando o os dados dessa base e consequentemente os cadastros de alguns funcionários"
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setEdit((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root backgroundColor="#00517D" onClick={handleEditSubmit}>
            <Button.Content title="Salvar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={confirm}
        setIsOpenController={() => location.reload()}
      >
        <Modal.Header onclick={() => setConfirm((prev) => !prev)} />
        <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
        <Modal.Content
          value="Dados atualizados!"
          subvalue="Ao acessar novamente as informações de bases, você verá as novas informações cadastradas."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => location.reload()}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </>
  )
}
